import {
  createStripeSubscriptionAction,
  getPricesLoader,
} from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import { Outlet } from 'react-router-dom'
import PlansPage from './PlansPage'

const checkoutRoutes = [
  {
    path: '',
    element: <Outlet />,
    children: [
      {
        action: createStripeSubscriptionAction,
        // The realtime-speaking perk belonged to the retired second yearly box,
        // so it is off for the single-yearly line-up.
        element: <PlansPage hidePerks />,
        loader: getPricesLoader,
        path: 'plans',
      },
    ],
  },
]

export default checkoutRoutes
